// extracted by mini-css-extract-plugin
export default {"wrapper":"SliceBorder_wrapper__dPe80","svg":"SliceBorder_svg__bFn2c"};